/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentType {
  DIF = 'dif',
  PIRF = 'pirf',
  PRIVACY = 'privacy',
}
